import MoveAndRotate from "./moveAndRotate";

class MoveBranch extends MoveAndRotate {
    branchIdList;
    animateMovement;
    animateTime;

    constructor(props) {
        super(props);
        this.branchIdList = props.branchIdList;
        this.animateMovement = props.animateMovement;
        this.animateTime = props.animateTime;
    }

    async stop() {
        changePerformMoveOnGroup(true);
        for (const branchId of this.branchIdList) {
            AnimationPlayer.stopConflictingMeshAnimations(AnimationPlayer.meshType.TREE, branchId);
        }
        changePerformMoveOnGroup(false);
    }

    async execute() {
        const volumeFinalMatrix = this.getComposedMatrix();
        changePerformMoveOnGroup(true);

        if (this.animateMovement === undefined) {
            this.animateMovement = true;
        }
        if (!this.animateTime) {
            this.animateTime = 2000;
        }

        let branchIdArray = [];
        for (let branchId of this.branchIdList) {
            const node = MeshHierarchyViewFeatureData.getDataFromBranchID(branchId);
            branchIdArray = node ? node.getLeaves() : [];
            if (branchIdArray.length > 0) {
                break;
            }
        }

        if (branchIdArray.length > 0) {
            let volumeCurrentMatrix = new THREE.Matrix4();
            if (moved_volume_matrices[branchIdArray[0]]) {
                volumeCurrentMatrix.copy(moved_volume_matrices[branchIdArray[0]]);
            }

            let applyMatrix = volumeFinalMatrix.clone();
            if (!this.transitionValues) {
                // make the applyMatrix an offset or transition matrix to apply it on volume's current position and orientation
                volumeCurrentMatrix.invert();
                applyMatrix.multiply(volumeCurrentMatrix);
                applyMatrix = getTransformationMatrixForVolumeExplosion(modelManager.getVolume(branchIdArray[0]), applyMatrix);
            }

            for (let branchId of this.branchIdList) {
                AnimationPlayer.stopConflictingMeshAnimations(AnimationPlayer.meshType.TREE, branchId);

                if (this.animateMovement) {
                    CADModelTransformationAnimationManager.transformVolumeWithAnimation(branchId, applyMatrix, undefined, this.animateTime);
                } else {
                    CADModelTransformationAnimationManager.transformVolumeWithoutAnimation(branchId, applyMatrix);
                }
            }
        }
        changePerformMoveOnGroup(false);
    }
}

export default MoveBranch;
